import axios from 'axios';
import { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { AuthCardBanner } from '../../components/AuthCardBanner';
import { TextInput } from '../../components/Inputs';
import { GradientButton } from '../../components/Buttons';

function ForgotPassword() {
  useEffect(() => {
    document.title = 'Reset Password | PromptSlate';
  }, []);
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      navigate('/dashboard');
    }
  }, [navigate]);

  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [status, setStatus] = useState(false);

  const handleStartRecovery = async (event: React.FormEvent<HTMLFormElement>) => {
    setErrorMessage('');
    event.preventDefault();

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/auth/start-recovery`, {
        email,
      });

      setStatus(true);
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        // Error response from the server
        setErrorMessage(error.response.data.message || 'Something went wrong!');
      } else {
        // Network or unknown error
        setErrorMessage('An unknown error occurred.');
      }
    }
  };

  return (
    <div className="flex flex-row items-center justify-center h-screen bg-[#f8f7f2]">
      <div className="flex flex-row items-stretch w-4/12 h-[500px] bg-[#fcfcf7] border rounded-xl p-6 shadow-sm">
        <AuthCardBanner />
        <div className="w-7/12 flex flex-col justify-center p-4 pl-12">
          <span className="font-playfair text-xl font-semibold">Reset your password</span>
          {errorMessage && <div className="text-red-600 text-sm mt-5">{errorMessage}</div>}
          {status ? (
            <div className="w-80">
              If you have an account with us, we will send the password reset instructions via email
            </div>
          ) : (
            <div className="flex flex-col">
              <form onSubmit={handleStartRecovery} className="flex flex-col">
                <TextInput
                  type="email"
                  placeholder="Registered Email"
                  className="mt-8"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <GradientButton type="submit" className="mt-5 w-full">
                  Reset password
                </GradientButton>
              </form>
              <span className="text-sm mt-6 text-[#606060]">
                <NavLink to="/login">or login instead</NavLink>
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
